import React from "react";
import { SupportTrayTab } from "./sample/SupportTrayTab.jsx";

export default function SupportTray() {
  return (
    <div>
      <SupportTrayTab />
    </div>
  );
}